import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNaviconHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.25 9H19.75C19.3358 9 19 9.33579 19 9.75V15.75C19 16.1642 19.3358 16.5 19.75 16.5H26.25C26.6642 16.5 27 16.1642 27 15.75V9.75C27 9.33579 26.6642 9 26.25 9Z",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.25 19H19.75C19.3358 19 19 19.3358 19 19.75V26.25C19 26.6642 19.3358 27 19.75 27H26.25C26.6642 27 27 26.6642 27 26.25V19.75C27 19.3358 26.6642 19 26.25 19Z",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 9H9.75C9.33579 9 9 9.33579 9 9.75V15.75C9 16.1642 9.33579 16.5 9.75 16.5H16.25C16.6642 16.5 17 16.1642 17 15.75V9.75C17 9.33579 16.6642 9 16.25 9Z",
			stroke: "#1D1D1D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.25 19H9.75C9.33579 19 9 19.3358 9 19.75V26.25C9 26.6642 9.33579 27 9.75 27H16.25C16.6642 27 17 26.6642 17 26.25V19.75C17 19.3358 16.6642 19 16.25 19Z",
			stroke: "#1D1D1D"
		})
	]
});
export default SvgNaviconHome;
